import { useCheckinHandlerResult } from '../../ServiceContext'

export const useOnSuccess = notify => {
  const [_handlerResult, setHandlerResult] = useCheckinHandlerResult()

  return session => {
    setHandlerResult && setHandlerResult('success')
    return notify.success({ title: `Nova integração com sucesso!` })
  }
}
